/*
  <otcg-countdown data-end="2026-11-30T20:00:00+02:00">
  Ticks down to the giveaway end, in step with the clock's seconds. Each digit that
  changes gets a short slide-in (CSS, skipped under prefers-reduced-motion).
  Shows the closed message at zero. An invalid date hides the clock.
*/
if (!customElements.get('otcg-countdown')) {
  class OtcgCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end || '');
      if (Number.isNaN(this.end)) {
        this.hidden = true;
        return;
      }
      this.units = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]'),
      };
      this.tick = this.tick.bind(this);
      this.tick(true);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
    }

    tick(first) {
      const left = Math.max(0, this.end - Date.now());
      const total = Math.floor(left / 1000);
      const values = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60,
      };
      Object.keys(values).forEach((key) => {
        const el = this.units[key];
        if (!el) return;
        const text = String(values[key]).padStart(2, '0');
        if (el.textContent === text) return;
        el.textContent = text;
        if (first !== true) {
          el.classList.remove('is-tick');
          void el.offsetWidth; /* restart the animation */
          el.classList.add('is-tick');
        }
      });
      if (left === 0) {
        this.classList.add('is-closed');
        const closed = this.querySelector('.otcg-countdown__closed');
        if (closed) closed.hidden = false;
        const card = this.closest('.otcg-giveaway-card');
        if (card) card.dataset.ended = 'true';
        return;
      }
      /* Wake just after the next whole second so the digits change in rhythm. */
      this.timer = window.setTimeout(this.tick, 1000 - (Date.now() % 1000) + 15);
    }
  }
  customElements.define('otcg-countdown', OtcgCountdown);
}
